module.exports = __webpack_public_path__ + "static/media/sample_mll_dealer_new.8678681f.csv";